import { render, staticRenderFns } from "./Programs.vue?vue&type=template&id=c0365fd6&scoped=true&"
import script from "./Programs.vue?vue&type=script&lang=js&"
export * from "./Programs.vue?vue&type=script&lang=js&"
import style0 from "./Programs.vue?vue&type=style&index=0&id=c0365fd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0365fd6",
  null
  
)

export default component.exports